import {COUNTRY_CODE_TO_DV_MAPPING} from '@/constants/engine';
import {DomainValueReference} from '@/model/types';

export const mapClientCountryCodeToDomainValue = (countryCode?: string): string | DomainValueReference | null => {
  if (!countryCode) return null;

  if (!(countryCode in COUNTRY_CODE_TO_DV_MAPPING)) {
    return countryCode;
  }

  return {$ref: COUNTRY_CODE_TO_DV_MAPPING[countryCode as keyof typeof COUNTRY_CODE_TO_DV_MAPPING]};
};
